import { formatDate } from '@airship-platform/airship-patterns';
import { SanitizedTrimmedHtml } from '@airship-platform/jam-web/components';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { ServiceHistory } from '../../../../data-access/serviceHistory';

type DesktopServiceHistoryViewProps = {
  paginatedServiceHistory: ServiceHistory[];
  page: number;
  rowsPerPage: number;
  handleChangePage: (newPage: number) => void;
  setRowsPerPage: (rows: number) => void;
  totalServiceHistory: number;
};

const DesktopServiceHistoryView: React.FC<DesktopServiceHistoryViewProps> = ({
  paginatedServiceHistory,
  page,
  rowsPerPage,
  handleChangePage,
  setRowsPerPage,
  totalServiceHistory,
}) => (
  <>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          <TableCell>Service type</TableCell>
          <TableCell>Technician</TableCell>
          <TableCell>Details</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {!paginatedServiceHistory.length ? (
          <TableRow>
            <TableCell colSpan={4} align="center">
              No service history found
            </TableCell>
          </TableRow>
        ) : (
          paginatedServiceHistory.map((item) => (
            <TableRow key={item.jobId}>
              <TableCell>{formatDate(item.lastAppointmentDate)}</TableCell>
              <TableCell>
                <SanitizedTrimmedHtml
                  html={item.jobSummary}
                  variant="body3"
                  maxLength={250}
                  hideAirshipLogo={true}
                />
              </TableCell>
              <TableCell>{item.assignedUserFirstName}</TableCell>
              <TableCell>{item.status}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
    {paginatedServiceHistory.length !== 0 && (
      <TablePagination
        rowsPerPageOptions={[
          5,
          10,
          25,
          { label: 'All', value: totalServiceHistory },
        ]}
        colSpan={3}
        component="div"
        count={totalServiceHistory}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, newPage) => handleChangePage(newPage)}
        onRowsPerPageChange={(e) =>
          setRowsPerPage(parseInt(e.target.value, 10))
        }
      />
    )}
  </>
);

export default DesktopServiceHistoryView;
